import { Specializations } from '../lookupsManagement/Specializations';

export class SectorDetails {
    id: number;
    nameEn: string;
    nameFr: string;
    referenceCount: number;
    specializations: Specializations[] = [];
}
